module.exports = __webpack_public_path__ + "24f4d8c61f496d13d2001b74de1c3adc.svg";